import { Mark } from '@tiptap/pm/model'
import { EditorState } from '@tiptap/pm/state'

/* eslint-disable unicorn/consistent-destructuring */

export default function getMarkAttributesForCurrentSelection(
  state: EditorState,
  markName: string
): Record<string, any> {
  const { from, to, empty } = state.selection
  let marks: Mark[] = []

  if (empty) {
    // TODO resolve types conflicts between tiptap and prosemirror
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    marks = state.storedMarks || state.selection.$head.marks()
  } else {
    state.doc.nodesBetween(from, to, (node) => {
      // TODO resolve types conflicts between tiptap and prosemirror
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      marks = [...marks, ...node.marks]
    })
  }

  const mark = marks.find((markItem) => markItem.type.name === markName)

  if (mark) {
    return { ...mark.attrs }
  }

  return {}
}
